module.exports = __webpack_public_path__ + "static/img/Yearinbusiness.509a56c5.png";